import React from 'react'
import { Container } from 'react-bootstrap'
import Slider from 'react-slick'
import  './../assest/style/certification.css'
import c1 from './../assest/images/projectss/certification/digital.png'
import c2 from './../assest/images/projectss/certification/e.png'
import c3 from './../assest/images/projectss/certification/icdl.png'
import c4 from './../assest/images/projectss/certification/internet.png'
import c5 from './../assest/images/projectss/certification/marketing.png'
import c6 from './../assest/images/projectss/certification/paid.png'
import c7 from './../assest/images/projectss/certification/product.png'
import c8 from './../assest/images/projectss/certification/seo.png'
import c9 from './../assest/images/projectss/certification/time.png'

export const Certification = () => {
  const cdata = [
    {
      cover: c1,
    },
    {
      cover: c2,
    },
    {
      cover: c3,
    },
    {
      cover: c4,
    },
    {
      cover: c5,
    },
    {
      cover: c6,
    },
    {
      cover: c7,
    },
    {
      cover: c8,
    },
    {
      cover: c9,
    },
  ];

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      }
    ]
  };
  return (
    <div className='certi'>
        <Container>
<div className='row'>
<Slider {...settings}>
    {cdata.map((value,index)=>{
        return(
            <div className='' key={index}>
              
                <div className='img'>
                <img src={value.cover}/>
                </div>
                
            </div>
        )
    }) }
    </Slider>
</div>
        </Container>
    </div>
  )
}

